import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../ui/dialog';
import { Button } from '../ui/button';
import { AlertTriangle, X, Upload, SkipForward } from 'lucide-react';

export const DuplicateWarningModal = ({ open, duplicateData, onForceImport, onImportWithout, onCancel }) => {
  if (!duplicateData) return null;

  const { duplicate_count, total_checked, duplicates } = duplicateData;
  const cleanCount = total_checked - duplicate_count;

  return (
    <Dialog open={open} onOpenChange={(v) => !v && onCancel()}>
      <DialogContent className="bg-zinc-950 border-red-500/40 max-w-2xl max-h-[80vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle className="text-red-400 text-lg flex items-center gap-2">
            <AlertTriangle className="h-5 w-5" />
            Doublons détectés — {duplicate_count} billet(s) déjà en base
          </DialogTitle>
        </DialogHeader>

        <p className="text-zinc-400 text-sm">
          Sur <span className="text-white font-semibold">{total_checked}</span> billets à importer, 
          <span className="text-red-400 font-semibold"> {duplicate_count}</span> sont déjà présents (même match, session, catégorie, emplacement).
          Veuillez vérifier et choisir une action.
        </p>

        {/* Duplicate list */}
        <div className="max-h-60 overflow-y-auto space-y-1 mt-2">
          {duplicates.slice(0, 20).map((dup, idx) => (
            <div key={idx} className="flex items-center justify-between bg-red-500/5 border border-red-500/20 rounded px-3 py-2 text-xs">
              <div className="text-white">
                <span className="text-zinc-400">#{dup.index + 1}</span>{' '}
                <span className="font-medium">{dup.new_ticket.evenement?.substring(0, 35)}</span>{' '}
                <span className="text-zinc-500">|</span>{' '}
                <span className="text-amber-400">{dup.new_ticket.categorie}</span>{' '}
                <span className="text-zinc-500">|</span>{' '}
                T:{dup.new_ticket.tribune} R:{dup.new_ticket.rang} P:{dup.new_ticket.place}
              </div>
              <span className="text-red-400 shrink-0 ml-2">Déjà existant</span>
            </div>
          ))}
          {duplicates.length > 20 && (
            <p className="text-zinc-500 text-xs text-center py-1">
              ... et {duplicates.length - 20} autre(s) doublon(s)
            </p>
          )}
        </div>

        {/* Actions */}
        <div className="flex flex-col gap-2 mt-4">
          {cleanCount > 0 && (
            <Button 
              onClick={onImportWithout}
              className="bg-emerald-600 hover:bg-emerald-500 text-white w-full"
              data-testid="import-without-duplicates-btn"
            >
              <SkipForward className="h-4 w-4 mr-2" />
              Importer uniquement les {cleanCount} nouveau(x) billet(s) (sans doublons)
            </Button>
          )}
          <Button 
            onClick={onForceImport}
            variant="outline"
            className="border-amber-500/40 text-amber-400 hover:bg-amber-500/10 w-full"
            data-testid="force-import-btn"
          >
            <Upload className="h-4 w-4 mr-2" />
            Importer quand même tous les {total_checked} billets (avec doublons)
          </Button>
          <Button 
            onClick={onCancel}
            variant="ghost"
            className="text-zinc-400 hover:text-white w-full"
            data-testid="cancel-import-btn"
          >
            <X className="h-4 w-4 mr-2" />
            Annuler et corriger
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default DuplicateWarningModal;
